import { createElement, styled, composedProps } from '@vebox/etui-system';

const H4Element = createElement('h4');
const H4 = styled(H4Element)(composedProps);

export { H4 };
